import { create } from 'jss';
import { jssPreset } from '@material-ui/core/styles';
import jssPluginVendorPrefixer from 'jss-plugin-vendor-prefixer';

const jss = create({
  plugins: [...jssPreset().plugins, jssPluginVendorPrefixer()],
});

export default jss;
